import { MenuItem, Select, Stack, Typography } from "@mui/material";

export type NetworkSortType = "CONTACT_NAME" | "COMPANY_NAME" | "DATE_ADDED";

const SORT_OPTIONS: { value: NetworkSortType; label: string }[] = [
  { value: "CONTACT_NAME", label: "Contact Name" },
  { value: "COMPANY_NAME", label: "Company Name" },
  { value: "DATE_ADDED", label: "Date Added" },
];

interface Props {
  value: NetworkSortType;
  onChange: (value: NetworkSortType) => void;
}

export function NetworkSortMenu(props: Props) {
  const { value, onChange } = props;

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography variant="body2" color="text.secondary" noWrap>
        Sort by:
      </Typography>
      <Select
        size="small"
        value={value}
        onChange={(e) => onChange(e.target.value as NetworkSortType)}
        sx={{ minWidth: 170, backgroundColor: "background.paper" }}
      >
        {SORT_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
}
